import type { ReactNode } from "react";
import { vars } from "@pack-it-up/ui-web";

// Section header shared by Home, My Trips, My Templates: display font, a count badge,
// and an optional right-aligned link/action.
export const SectionHead = ({ title, count, link }: { title: string; count?: string; link?: ReactNode }): ReactNode => (
  <div style={{ display: "flex", alignItems: "baseline", gap: vars.space.sm, marginBottom: vars.space.md }}>
    <span
      style={{
        fontFamily: vars.font.heading,
        fontWeight: vars.font.weightBold,
        fontSize: vars.font.sizeMd,
        letterSpacing: vars.font.trackingSnug,
        color: vars.color.text,
      }}
    >
      {title}
    </span>
    {count !== undefined && <span style={{ fontSize: vars.font.sizeXs, color: vars.color.textMuted }}>{count}</span>}
    {link !== undefined && <span style={{ marginLeft: "auto" }}>{link}</span>}
  </div>
);
